import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const MentalHealthIcon: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    viewBox="0 0 53 53"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M44.712 26.982L41.4132 16.8804L41.4124 16.8824C39.2507 9.97857 32.8057 4.96875 25.1892 4.96875C15.8013 4.96875 8.19092 12.5793 8.19092 21.9671C8.19092 27.5228 10.8684 32.4411 14.9903 35.5425V41.2318L31.9886 48.0312V40.0987H35.3882C39.1434 40.0987 42.1875 37.0545 42.1875 33.2993V29.8997H42.541C44.0594 29.8996 45.1483 28.4362 44.712 26.982Z"
      fill="#002677"
    />
    <path
      d="M29.9135 11.9085C28.2885 10.2837 25.6539 10.2837 24.029 11.9085L23.1043 12.8332L22.1797 11.9085C20.5548 10.2837 17.9202 10.2837 16.2952 11.9085C14.6702 13.5336 14.6702 16.1681 16.2952 17.7931L17.2198 18.7176L23.1026 24.6004L23.1043 24.5986L23.1061 24.6004L29.9135 17.7931C31.5385 16.1681 31.5385 13.5336 29.9135 11.9085Z"
      fill="#FF612B"
    />
  </Box>
)

export default MentalHealthIcon
